import { api } from "./api"

export const GET_FILES = async () => {
    const {data} = await api.get("/files/all")
    return data.files || [];
}

export const GET_FILE_TYPES = async () => {
    const {data} = await api.get("/files/types")
    return data.file_types || [];
}

export const UPLOAD = async (formData: any) => {
    const {data} = await api.post(`/files/upload`, formData, {
        headers: { "content-type": "multipart/form-data", },
    });
    return data;
}

export const IMPORT_FILE = async (params : any) => {
    const {data} = await api.post(`/files/import`, params, {
        headers: { "content-type": "multipart/form-data", },
    });
    return data;
}

export const SAVE_IMAGE = async (params : any) => {
    const {data} = await api.post(`/files/save/image`, params, {
        headers: { "content-type": "multipart/form-data", },
    });
    return data;
}

export const GET_IMPORTING_FILES = async () => {
    const {data} = await api.get(`/files/importing`);
    return data.files || [];
}

export const SAVE_FILE = async (params: any) => {
    const {data} = await api.post(`/files/save`, params);
    return data;
}

export const DELETE_FILE = async (fileId) => {
    const {data} = await api.delete(`/files/${fileId}`);
    return data;
}
